import { useRequest } from "ahooks";

import { useState } from "react";

import { Box, CircularProgress, Divider, Skeleton, Switch, Typography } from "@mui/material";

import { ApiGetUserEmailData, getUserEmail, setUserEmail } from "@/api/account";
import { useQuery } from "@/hooks/useQuery";
import useThemeData from "@/hooks/useThemeData";

const Email = () => {
  const theme = useThemeData();

  const { token } = useQuery<{ token: string }>();

  const [currentKey, setCurrentKey] = useState<string>("");

  const {
    loading,
    data: userEmailData,
    // refreshAsync: getUserEmailData,
    mutate,
  } = useRequest(() => getUserEmail(token || undefined));

  const { loading: changeGeneralEmailLoading, runAsync: changeGeneralEmail } = useRequest(
    setUserEmail,
    { manual: true }
  );

  const SwitchIcon = (props: { uuid: string }) => {
    const current = userEmailData?.data.email_info_lst.find((item) => item.key === props.uuid);
    if (props.uuid === currentKey) {
      return (
        <div
          className="flex items-center justify-center w-[20px] h-[20px] rounded-[50%]"
          style={{
            backgroundColor:
              current?.value && !changeGeneralEmailLoading
                ? theme.palette.primary.main
                : theme.palette.background.default,
          }}
        >
          {changeGeneralEmailLoading && (
            <CircularProgress size={14} color="primary" thickness={6} />
          )}
        </div>
      );
    } else {
      return (
        <div
          className="flex items-center justify-center w-[20px] h-[20px] rounded-[50%]"
          style={{
            backgroundColor: current?.value
              ? theme.palette.primary.main
              : theme.palette.background.default,
          }}
        />
      );
    }
  };

  return (
    <div>
      <Typography variant="h4">Email Setting</Typography>
      <Typography className="!mt-[10px]">You email : {userEmailData?.data?.email}</Typography>

      {loading ? (
        <Box className="mt-[30px] flex items-center justify-between">
          <div>
            <Skeleton width={120} height={35} animation="wave" className="mb-[4px]" />
            <Skeleton width={200} animation="wave" className="mb-[4px]" />
          </div>
          <Skeleton width={50} height={30} animation="wave" className="mb-[4px]" />
        </Box>
      ) : (
        <div className="mt-[30px]">
          {userEmailData?.data.email_info_lst.map(({ key, value, name, description }, index) => (
            <div key={key}>
              <Divider />
              <div className="flex justify-between items-center py-[20px] px-[30px]">
                <div>
                  <Typography variant="h6">{name}</Typography>
                  <Typography variant="subtitle2">{description}</Typography>
                </div>
                <div>
                  <Switch
                    checkedIcon={<SwitchIcon uuid={key} />}
                    icon={<SwitchIcon uuid={key} />}
                    checked={value}
                    onChange={async (_, checked) => {
                      try {
                        setCurrentKey(key);
                        await changeGeneralEmail({
                          email_lists: {
                            [key]: checked,
                          },
                          data: token || undefined,
                        });

                        mutate((state: ApiGetUserEmailData) => {
                          return {
                            ...state,
                            data: {
                              ...state.data,
                              email_info_lst: state?.data.email_info_lst.map((item) => {
                                if (item.key === key) {
                                  return {
                                    ...item,
                                    value: checked,
                                  };
                                }
                                return item;
                              }),
                            },
                          } as ApiGetUserEmailData;
                        });
                        // getUserEmailData();
                      } catch (error) {
                        console.error(error);
                      }
                    }}
                  />
                </div>
              </div>
              {index === userEmailData?.data.email_info_lst.length - 1 && <Divider />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Email;
